// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)

export const sharedComponentValues = {
  defaultValues: {
    singleLineNumberPlaceholder: '4242 4242 4242 4242',
    formNumberPlaceholder: 'Card number',
    expirationPlaceholder: 'MM/YY',
    cvvPlaceholder: 'CVV',
    postalCodePlaceholder: 'Postal code',
  },
};
